/**
 * @generated SignedSource<<c498c9db7a3830bd7ad1ec6a5919e0f4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateIntegrationDescriptionInput = {
  description?: string | null | undefined;
  integrationId: any;
};
export type DatadogIntegrationsDialogUpdateDescriptionMutation$variables = {
  input: UpdateIntegrationDescriptionInput;
};
export type DatadogIntegrationsDialogUpdateDescriptionMutation$data = {
  readonly updateIntegrationDescription: {
    readonly error: string | null | undefined;
    readonly integration: {
      readonly description: string | null | undefined;
      readonly id: any;
    } | null | undefined;
  };
};
export type DatadogIntegrationsDialogUpdateDescriptionMutation = {
  response: DatadogIntegrationsDialogUpdateDescriptionMutation$data;
  variables: DatadogIntegrationsDialogUpdateDescriptionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateIntegrationDescriptionPayload",
    "kind": "LinkedField",
    "name": "updateIntegrationDescription",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GraphQLIntegration",
        "kind": "LinkedField",
        "name": "integration",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "description",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DatadogIntegrationsDialogUpdateDescriptionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DatadogIntegrationsDialogUpdateDescriptionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "9bfe79c3b79a26da8c35ae47a3c5b53f",
    "id": null,
    "metadata": {},
    "name": "DatadogIntegrationsDialogUpdateDescriptionMutation",
    "operationKind": "mutation",
    "text": "mutation DatadogIntegrationsDialogUpdateDescriptionMutation(\n  $input: UpdateIntegrationDescriptionInput!\n) {\n  updateIntegrationDescription(input: $input) {\n    integration {\n      id\n      description\n    }\n    error\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e5e412580f51e11ca1d41afffe79008";

export default node;
